import { render, staticRenderFns } from "./AddInputOption.vue?vue&type=template&id=460b7acd&"
import script from "./AddInputOption.vue?vue&type=script&lang=js&"
export * from "./AddInputOption.vue?vue&type=script&lang=js&"
import style0 from "./AddInputOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports